<div class="custom-dialog px-px-32 py-px-24">
  <div class="fw-7 fs-20">{{data.title}}</div>
  <div class="fw-3 fs-16"> {{data.description}} </div>
  <form *ngIf="data.withFormInput" [formGroup]="form">
    <app-custom-input [placeholder]="data.formInputPlaceholder!" [label]="data.formInputLabel!" innerClass="my-px-16" [required]="false" [parentForm]="form"
                      [max]="200" [controlName]="'formValue'" type="textarea"></app-custom-input>
  </form>
  <mat-dialog-actions align="end" class="mt-px-24">
    <app-button [text]="data.secondaryLabel" [stroked]="true" (handleClick)="close(false)"></app-button>
    <app-button [text]="data.primaryLabel" (handleClick)="close(true)" innerClass="ml-px-8" ></app-button>
  </mat-dialog-actions>
</div>
